// Basic
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FlexLayoutModule } from '@angular/flex-layout';

// Modules
import { MaterialModule } from '@app/material.module';

// Components
import { MobileBottomMenuComponent } from './mobile-bottom-menu.component';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    FlexLayoutModule,
    MaterialModule
  ],
  declarations: [MobileBottomMenuComponent],
  exports: [MobileBottomMenuComponent],
  entryComponents: [MobileBottomMenuComponent]
})
export class MobileBottomMenuComponentModule { }
